import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AppTopNavbarComponent } from './core/components/navbar/navbar';
import { FullscreenService } from './core/services/fullscreen.service';
import { isPlatformRealmActive } from './core/config/platform-realm';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppTopNavbarComponent, NgClass, ToastModule, ConfirmDialogModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly fullscreen = inject(FullscreenService);

  /**
   * Whether this page load is the back office's. Decided once, before the app
   * bootstraps, so it cannot change under a navigation — crossing between a
   * shop and the back office costs a reload either way.
   */
  protected readonly backOffice = isPlatformRealmActive();
}
